// src/components/barLounge/MenuItem.js
import React from 'react';

const MenuItem = ({ name, price, glass }) => {
  return (
    <div className="menu-item">
      <div className="item-details">
        <span className="item-name">{name}</span>
      </div>
      <div className="item-meta">
        <span className="item-price">¥{typeof price === 'number' ? price.toLocaleString() : price}</span>
        {glass && <span className="item-glass">{glass}</span>}
      </div>
    </div>
  );
};

export default MenuItem;